import { PAYMENT_TYPE } from '../../../../../../lib/constants'

export function getDefaultPaymentType({
  flowType,
  isPurchase,
  defaultPaymentType,
}) {
  const pathName = window.location.pathname
  const isGoodAndServices = pathName.includes('buy/preview')
  const isFriendsAndFamily = pathName.includes('send/preview')

  if (isGoodAndServices) {
    return PAYMENT_TYPE.PURCHASE
  }

  if (isFriendsAndFamily) {
    return PAYMENT_TYPE.PERSONAL
  }

  if (flowType === 'payRequest') {
    return isPurchase ? PAYMENT_TYPE.PURCHASE : PAYMENT_TYPE.PERSONAL
  }

  return defaultPaymentType
}
